import { RESET_ANAGRAFE_STATE, RICERCA_COMUNI, RICERCA_COMUNI_SUCCESS, RICERCA_ISCRIZIONE, RICERCA_ISCRIZIONE_SUCCESS } from "./actionsType"


export const ricercaIscrizioneAction = () => ({
    type: RICERCA_ISCRIZIONE
})

export const ricercaIscrizioneActionSuccess = (payload) => ({
    type: RICERCA_ISCRIZIONE_SUCCESS,
    payload
})

export const ricercaComuniAction = (aslId) => ({
    type: RICERCA_COMUNI,
    aslId
})

export const ricercaComuniActionSuccess = (payload) => ({
    type: RICERCA_COMUNI_SUCCESS,
    payload
})

export const resetAnagrafeStateAction = () => ({
    type: RESET_ANAGRAFE_STATE
})
